/**
 * Created by rak on 30/06/2016.
 */
'use strict';
angular.module('driverDashboard', ['ui.router']).config(function ($stateProvider) {
  $stateProvider
    .state('driverdashboard',{
      parent: 'betotrack',
      url: '/driverdashboard',
      ncyBreadcrumb: {
        label: 'Track'
      },
      views: {
        'content@app': {
          templateUrl: 'components/dashboard/driverDashboard/driverDashboard.tpl.html',
          controller: 'DriverDashboardCtrl'
        }
      },
      resolve: {
        $title: function () {          
          return 'BetoTrack', 'Fleet Management Dashboard';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/driverDashboard/driverDashboard.js